export let getLoggedUser = (state) => state.admin.byId[state.auth.logged_user]

export let getCurrentBusiness = (state) => state.business.byId[state.auth.current_business]